import React, { HTMLProps } from "react";
import { MdChevronRight } from "react-icons/md";
import "./styles.scss";

interface StoreItemProps extends HTMLProps<HTMLAnchorElement> {
  urlImage: string;
  altImage: string;
}

function StoreItem({ altImage, urlImage, ...rest }: StoreItemProps) {
  return (
    <a {...rest} className="storeItem">
      <img src={urlImage} alt={altImage} />
    </a>
  );
}

export { StoreItem };
